// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const InvertColorOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M17.33 8.24L12 2.9 6.67 8.24a7.54 7.54 0 1010.66 0zM12 19.22a5.58 5.58 0 01-5.22-3.49A5.6 5.6 0 018 9.57l3.99-4v13.65z","fill":"currentColor"}}]},"name":"invert-color","theme":"outlined"};

const InvertColorOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={InvertColorOutlinedSvg} />;
  InvertColorOutlined.displayName = 'InvertColorOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(InvertColorOutlined);
